import { render, staticRenderFns } from "./editStaff.vue?vue&type=template&id=3fc7b45a&"
import script from "./editStaff.vue?vue&type=script&lang=js&"
export * from "./editStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports